export const AB_TEST_TYPES = {
    BUYER_CLIENT: 'BUYER_CLIENT',
    BUYER_COOKIE: 'BUYER_COOKIE',
    BUYER_USER: 'BUYER_USER',
    SELLER: 'SELLER',
    EMAIL: 'EMAIL',
    BUYER_APP_INSTANCE: 'BUYER_APP_INSTANCE',
    BUYER_APP_USER: 'BUYER_APP_USER',
    SELLER_APP: 'SELLER_APP',
} as const;

export const BUYER_COOKIE_TEST_TYPES = [AB_TEST_TYPES.BUYER_CLIENT, AB_TEST_TYPES.BUYER_COOKIE];
